<template lang="pug">
.produtividade-container
  el-row
    el-col(:md="24", :lg="12")
      app-plotly(nomeDiv="graficoProcessoPorSetor", :dados="graficoDados", :layout="layout", :centralizarGrafico="true")
    el-col(:md="24", :lg="12")
      el-table(
        :data="dadosWithColor"
        @row-click="produtividadePorSetor"
      )
        template(slot="empty")
          | Nenhuma produtividade encontrada.
        el-table-column(
          label="Nome",
          prop="nome",
          :formatter="nomeFormatado"
        )
        el-table-column(
          label="Produtividade",
          prop="produtividade"
          align="center",
          width="150"
        )
          template(slot-scope="scope")
            div.tabela-produtividade
              .content-tabela-produtividade(:style="`--color: ${scope.row.color}`")
                span {{ scope.row.produtividade }}
        el-table-column(
          label="Ação",
          align="center",
          width="55",
        )
          el-tooltip(content='Visualizar produtividade', placement='bottom')
            i.fa.fa-eye

</template>

<script>
import AppPlotly from '@/components/AppPlotly'

export default {
  components: {
    AppPlotly
  },
  data () {
    return {
      colors: ['#F2A74B', '#038C65', '#1C79A6', '#0F4786', '#A61C5C',
        '#FF6633', '#FFB399', '#FF33FF', '#00B3E6',
        '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
        '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
        '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
        '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
        '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
        '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
        '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
        '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
        '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'],
      loading: true
    }
  },

  props: {
    dadosLabels: {
      type: Array,
      required: true
    }
  },

  computed: {
    dadosWithColor () {
      return this.dadosLabels.map((dado, index) => ({
        ...dado,
        color: this.colors[index]
      }))
    },

    graficoDados () {
      if (_.isEmpty(this.dadosLabels)) {  // eslint-disable-line
        return []
      }

      const graficoDados = [{
        values: [],
        labels: [],
        domain: { column: 0 },
        name: '',
        textinfo: 'none',
        hovertemplate: '<br>%{label}' +
                        '<br>%{value}' +
                        '<br>%{percent}',
        hole: 0.58,
        type: 'pie',
        marker: {
          colors: []
        }
      }]

      this.dadosWithColor.forEach((dado) => {
        graficoDados[0].labels.push(dado.nome)
        graficoDados[0].values.push(dado.produtividade)
        graficoDados[0].marker.colors.push(dado.color)
      })

      return graficoDados
    },
    hasData () {
      return !_.isEmpty(this.dados)   // eslint-disable-line
    },
    layout () {
      return {
        showlegend: false,
        height: 450,
        width: 400,
        annotations: [
          {
            font: {
              size: 30
            },
            showarrow: false,
            text: this.totalDados,
            x: 0.5,
            y: 0.5
          }
        ]
      }
    },
    totalDados () {
      return this.dadosLabels.reduce((total, dado) => total + dado.produtividade, 0)
    }
  },
  methods: {
    produtividadePorSetor (analista) {
      let idsServidores = []
      this.dadosWithColor.forEach(element => {
        idsServidores.push(element.idUsuario)
      })
      this.$emit('produtividadePorSetor', analista.nome, idsServidores)
    },
    nomeFormatado (prop) {
      if (prop.nome !== null) {
        return prop.nome.toUpperCase()
      }
      return ' - '
    }
  }
}
</script>
<style lang="scss" scoped>
.produtividade-container {

  .el-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  /deep/ .el-table .el-table__row {
    cursor: pointer;
  }

  .tabela-produtividade {
    display: flex;
    justify-content: center;
    color: white;

    .content-tabela-produtividade {
      width: 72px;
      background-color: var(--color);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/produtividade/components/GraficoProcessoPorSetor.vue